import {
  Button,
  Callout,
  Field,
  FieldLabel,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@/components/ui";
import type { CancelReasonCode } from "@/features/Charting/RoomOptions/network/useCancelReasonCodes";

interface RequiresLiveVisitRejectionContentProps {
  reasonCodes?: CancelReasonCode[];
  cancelReasonCode: string;
  onCancelReasonCodeChange(cancelReasonCode: string): void;
  cancelReasonText: string;
  onCancelReasonTextChange(cancelReasonText: string): void;
  onSubmit?: () => void | Promise<void>;
  isSending?: boolean;
  showSubmitButton?: boolean;
}

export function RequiresLiveVisitRejectionContent({
  reasonCodes,
  cancelReasonCode,
  onCancelReasonCodeChange,
  cancelReasonText,
  onCancelReasonTextChange,
  onSubmit,
  isSending = false,
  showSubmitButton = true,
}: RequiresLiveVisitRejectionContentProps) {
  return (
    <div className="gap-2 flex flex-col">
      <Callout
        variant="warning"
        title="Care plan will not be sent"
        description="Patient will be notified that a live visit is required."
      />
      <Field>
        <FieldLabel htmlFor="requires-live-visit-reason-code">
          This Async Visit cannot be approved because:
        </FieldLabel>
        <Select
          value={cancelReasonCode}
          onValueChange={onCancelReasonCodeChange}
        >
          <SelectTrigger
            id="requires-live-visit-reason-code"
            data-testid="requires-live-visit-reason-code"
          >
            <SelectValue placeholder="Select a reason" />
          </SelectTrigger>
          <SelectContent>
            {reasonCodes?.map(({ code, label }) => (
              <SelectItem key={code} value={code}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>
      <Field>
        <FieldLabel htmlFor="requires-live-visit-reason">
          Additional details (optional)
        </FieldLabel>
        <Textarea
          id="requires-live-visit-reason"
          data-testid="requires-live-visit-reason"
          value={cancelReasonText}
          onChange={(event) => onCancelReasonTextChange(event.target.value)}
          rows={6}
        />
      </Field>
      {showSubmitButton && (
        <div className="flex flex-row gap-2 justify-self-end">
          <Button
            className="w-fit ml-auto"
            size="sm"
            onClick={onSubmit}
            isLoading={isSending}
            disabled={!cancelReasonCode}
          >
            Notify: Async Cancellation Reason
          </Button>
        </div>
      )}
    </div>
  );
}
